<template>
  <section class="kwt-basic-dropdown">
    <div class="dropdown-head" @click="handleClickOnHead">
      <span>{{ this.selectedItem || 'Choose an item.' }}</span>
      <figure class="arrow-down"></figure>
    </div>
    <ul v-if="open">
      <li
        :key="index"
        v-for="(item, index) in items"
        @click="handleSelectItem(item)"
      >
        {{ item.text }}
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    id: {
      type: Number || String
    },
    onSelectItem: {
      type: Function,
      default: () => () => {}
    },
    handleOpen: {
      type: Function,
      default: () => () => {}
    },
    openDropdown: [Number, Object]
  },
  computed: {
    open() {
      return this.id === this.openDropdown;
    }
  },
  data() {
    return {
      selectedItem: null
    };
  },
  methods: {
    handleClickOnHead() {
      this.handleOpen(this.id);
    },
    handleSelectItem(item) {
      this.selectedItem = item.text;
      this.onSelectItem(item, this.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.kwt-basic-dropdown {
  * {
    box-sizing: border-box;
  }
  width: 100%;
  font-size: 20px;
  position: relative;

  .dropdown-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    width: 100%;
    min-height: 40px;
    height: auto;
    border: 2px solid black;
    padding: 5px 10px;
    font-size: 20px;
    text-align: left;
    font-weight: bold;
    position: relative;
    cursor: pointer;
  }

  figure {
    margin: 0 0 0 10px;
  }

  .arrow-down {
    width: 24px;
    height: 12px;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-top: 16px solid black;
  }
  //TODO: Refactor the <ul> in a separate component, when time allows
  ul {
    position: absolute;
    top: 100%;
    z-index: 2;
    margin: 0;
    padding: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    border: 2px solid black;
    max-height: 200px;
    overflow: auto;
  }

  li {
    list-style: none;
    width: 100%;
    padding: 5px 10px;
    border-bottom: 1px solid black;
    text-align: left;
    cursor: pointer;
    font-weight: bold;
    transition: 0.2s linear;

    &:last-child {
      border: none;
    }

    &:hover {
      background-color: lightgrey;
    }
  }
}
</style>
